import { FunctionComponent, useState } from "react";

import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

import { Autocomplete, TextField } from "@mui/material";

import { Icon } from "../Icon/Icon";
import { Information } from "../Information/Information";

export interface MultiAutoCompleteItem {
	id: number | string;
	title: string;
	icon?: JSX.Element;
}

export interface MultiAutoCompleteProps {
	handleSelect: (value?: MultiAutoCompleteItem[]) => void;
	selectedItems: MultiAutoCompleteItem[];
	data: MultiAutoCompleteItem[];
	label?: string;
	testId?: string;
	information?: string | JSX.Element;
	placeholder?: string;
	stayOn?: boolean;
}

export const MultiAutoComplete: FunctionComponent<MultiAutoCompleteProps> = ({
	handleSelect,
	selectedItems,
	data,
	label,
	information,
	placeholder,
	stayOn = false,
}) => {
	// const [selectedItems, setSelectedItems] = useState<MultiAutoCompleteItem[]>([]);
	const [inputValues, setInputValues] = useState<string>();

	return (
		<div className="relative  w-full">
			{label && (
				<label className="flex flex-row items-center block mb-2 text-sm font-medium text-gray-900 appearance-none">
					{label}
					{information && (
						<span className="ml-1">
							<Information information={information} />
						</span>
					)}
				</label>
			)}
			<Autocomplete
				disableCloseOnSelect={stayOn}
				multiple
				clearOnBlur={true}
				getOptionLabel={(option) => option.title}
				inputValue={inputValues || ""}
				isOptionEqualToValue={(option, currentValue) => {
					if (currentValue.title === "" && currentValue.id === "") {
						return true;
					}

					return option.id === currentValue.id;
				}}
				loadingText="Searching..."
				noOptionsText="No matching options"
				filterOptions={(options, { inputValue }) =>
					options.filter((option) => option.title.toLowerCase().includes(inputValue.toLowerCase()))
				}
				options={data?.filter((r) => r.id !== "") || []}
				popupIcon={<Icon className="text-gray-500 h-[24px] w-[15px]" icon={faChevronDown} />}
				renderInput={(params) => (
					<TextField
						{...params}
						label={placeholder || "Select an item"}
						placeholder={placeholder || "Select an item"}
						sx={{
							width: "100%",
							minHeight: 48,
							marginBottom: 1,
							"& .MuiFilledInput-root": {
								backgroundColor: "white",
								minHeight: 48,
								marginBottom: 0,
								borderRadius: 1.5,
								paddingTop: "10px",
								paddingBottom: "10px !important",
								paddingLeft: 1.5,
								"& .MuiChip-root": {
									backgroundColor: "#EAEEFF",
									color: "#1D3DF2",
								},
							},
							"& .MuiFilledInput-root:hover": {
								backgroundColor: "white",
							},
							"& .MuiInputLabel-root": {
								color: "#9CA3AF",
								fontSize: "16px",
								marginTop: "-4px",
							},
							"& .MuiInputLabel-root.MuiInputLabel-shrink": {
								display: "none",
							},
						}}
					/>
				)}
				size="small"
				sx={{
					width: "100%",
					marginBottom: 0,
					"& .MuiFormControl-root": {
						marginBottom: 0,
					},
				}}
				value={selectedItems || []}
				onBlur={(e) => {
					e.preventDefault();
					e.stopPropagation();
				}}
				onChange={(event, value) => {
					handleSelect(value || []);
					setInputValues("");
				}}
				onInputChange={(event, newValue, reason) => {
					if (reason === "input") {
						setInputValues(newValue);
					}
				}}
			/>
		</div>
	);
};
